export enum EVWriteBackStatus {
  NOT_INITIATED = "not_initiated",
  INITIATED = "initiated",
  QUEUED = "queued",
  IN_PROGRESS = "in_progress",
  SUCCESS = "success",
  ERROR = "error",
}

export enum DocWriteBackStatus {
  NOT_INITIATED = "not_initiated",
  INITIATED = "initiated",
  QUEUED = "queued",
  IN_PROGRESS = "in_progress",
  SUCCESS = "success",
  ERROR = "error",
}

export enum NarRpsStatus {
  NOT_INITIATED = "not_initiated",
  INITIATED = "initiated",
  QUEUED = "queued",
  IN_PROGRESS = "in_progress",
  SUCCESS = "success",
  ERROR = "error",
}
